// Import Firebase (usando la versione CDN già caricata nell'HTML)
const { initializeApp } = window.firebase;
const { getFirestore, collection, addDoc, getDocs, doc, getDoc, updateDoc, deleteDoc, orderBy, query, serverTimestamp } = window.firebase.firestore;

let estimatorIsVisible = false;
let developmentIsVisible = false;
let currentLoadedAccumulatorId = null;
let currentLoadedAccumulatorName = null;

// Configurazione di Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDqL7Zi_pvYzhzBaoer9UlTPFjd-xENG8I",
  authDomain: "multiplicatore1.firebaseapp.com",
  projectId: "multiplicatore1",
  storageBucket: "multiplicatore1.firebasestorage.app",
  messagingSenderId: "262529607201",
  appId: "1:262529607201:web:3d643d85aaa8967fb02560",
  measurementId: "G-1NVN2WNJRX"
};

// Inizializza Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

// Espone le funzioni globalmente per gli onclick nell'HTML
window.renderLegs = renderLegs;
window.toggleExpansion = toggleExpansion;
window.calculateAccumulatorOdds = calculateAccumulatorOdds;
window.calculateEstimation = calculateEstimation;
window.updateAllCoverage = updateAllCoverage;
window.calculateDevelopmentAutomatically = calculateDevelopmentAutomatically;
window.updateCoverage = updateCoverage;
window.estimator = estimator;
window.development = development;
window.clearAllInputs = clearAllInputs;
window.openSavePopup = openSavePopup;
window.closeSavePopup = closeSavePopup;
window.saveAccumulator = saveAccumulator;
window.openLoadOrDeletePopup = openLoadOrDeletePopup;
window.closeLoadOrDeletePopup = closeLoadOrDeletePopup;
window.loadAccumulator = loadAccumulator;
window.deleteAccumulator = deleteAccumulator;
window.updateAccumulator = updateAccumulator;
window.copyToClipboard = copyToClipboard;
window.attachCopyListeners = attachCopyListeners;

// Renderizza la tabella
function renderLegs() {
  const legs = parseInt(document.getElementById("legs").value);
  const primaryTable = document.getElementById("primaryTable");
  
  let tableHTML = `
  <table class="matchesTable">
    <colgroup>
      <col> <!-- PARTITA -->
      <col> <!-- DATA E ORA -->
      <col> <!-- MERCATO -->
      <col> <!-- Q.PUNTA -->
      <col> <!-- Q.BANCA -->
      <col> <!-- COMM. % -->
      <col> <!-- ESITI -->
    </colgroup>
    <thead>
        <tr>
          <th>PARTITA</th>
          <th>DATA E ORA</th>
          <th>MERCATO</th>
          <th>Q.PUNTA</th>
          <th>Q.BANCA</th>
          <th>COMM. %</th>
          <th>ESITI</th>
        </tr>
      </thead>
      <tbody>
  `;
  
  for (let i = 0; i < legs; i++) {
    tableHTML += `
      <tr>
        <td>
          <div class="matchWrapper">
            <button class="expandButton" onclick="toggleExpansion(${i})">
              <span class="arrow">▼</span>
            </button>
            <input type="text" id="match${i}">
          </div>
        </td>
        <td>
          <input type="datetime-local" id="date${i}">
        </td>
        <td>
          <input type="text" id="market${i}">
        </td>
        <td>
          <input type="number" id="backOdds${i}" oninput="calculateAccumulatorOdds(); calculateEstimation(); updateAllCoverage(); calculateDevelopmentAutomatically()">
        </td>
        <td>
          <input type="number" id="layOdds${i}" oninput="calculateEstimation(); updateAllCoverage(); calculateDevelopmentAutomatically()">
        </td>
        <td>
          <input type="number" id="commission${i}" value="4.5" oninput="calculateEstimation(); updateAllCoverage(); calculateDevelopmentAutomatically()">
        </td>
        <td>
          <div class="radioButtons">
            <label><input type="radio" name="status${i}" value="A" checked onchange="calculateDevelopmentAutomatically()"> A</label>
            <label><input type="radio" name="status${i}" value="V" onchange="calculateDevelopmentAutomatically()"> V</label>
            <label><input type="radio" name="status${i}" value="P" onchange="calculateDevelopmentAutomatically()"> P</label>
          </div>
        </td>
      </tr>
      <tr id="expansion${i}" class="expansionRow">
        <td colspan="7">
          <div class="expansionContent" id="expansionContent${i}">
            <div class="expansionGrid">
              <div class="initialData">
                <h4>DATI INIZIALI</h4>
                <div class="form1">
                  <span>Quota:</span>
                  <span id="initialLayOdds${i}">-</span>
                </div>
                <div class="form1">
                  <span>Comm.%:</span>
                  <span id="initialCommission${i}">4.50%</span>
                </div>
                <div class="form1">
                  <span>Bancata:</span>
                  <span id="initialLayAmount${i}">-</span>
                </div>
                <div class="form1">
                  <span>Abbinato:</span>
                  <input type="number" id="pairedAmount${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()">
                </div>
              </div>
              <div class="newOdds">
                <h4>QUOTE NUOVE</h4>                    
                <div class="oddsRow">
                  <div class="oddsColumn">
                    <input type="number" id="newOdds1${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Quota">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="newOdds2${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Quota">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="newOdds3${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Quota">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="newOdds4${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Quota">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="newOdds5${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Quota">
                  </div>
                </div>
                <div class="oddsRow">
                  <div class="oddsColumn">
                    <input type="number" id="newCommission1${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Comm.%">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="newCommission2${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Comm.%">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="newCommission3${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Comm.%">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="newCommission4${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Comm.%">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="newCommission5${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Comm.%">
                  </div>
                </div>
                <div class="oddsRow">
                  <div class="oddsColumn">
                    <div class="layAmountWrapper">
                      <span class="layAmountLabel">Bancata:</span>
                      <span class="layAmount" id="layAmount1${i}">-</span>
                    </div>
                  </div>
                  <div class="oddsColumn">
                    <div class="layAmountWrapper">
                      <span class="layAmountLabel">Bancata:</span>
                      <span class="layAmount" id="layAmount2${i}">-</span>
                    </div>
                  </div>
                  <div class="oddsColumn">
                    <div class="layAmountWrapper">
                      <span class="layAmountLabel">Bancata:</span>
                      <span class="layAmount" id="layAmount3${i}">-</span>
                    </div>
                  </div>
                  <div class="oddsColumn">
                    <div class="layAmountWrapper">
                      <span class="layAmountLabel">Bancata:</span>
                      <span class="layAmount" id="layAmount4${i}">-</span>
                    </div>
                  </div>
                  <div class="oddsColumn">
                    <div class="layAmountWrapper">
                      <span class="layAmountLabel">Bancata:</span>
                      <span class="layAmount" id="layAmount5${i}">-</span>
                    </div>
                  </div>
                </div>
                <div class="oddsRow">
                  <div class="oddsColumn">
                    <input type="number" id="pairedAmount1${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Abbinato">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="pairedAmount2${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Abbinato">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="pairedAmount3${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Abbinato">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="pairedAmount4${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Abbinato">
                  </div>
                  <div class="oddsColumn">
                    <input type="number" id="pairedAmount5${i}" oninput="updateCoverage(${i}); calculateDevelopmentAutomatically()" placeholder="Abbinato">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    `;
  }
  
  // Aggiungi la riga per la quota multipla e i bottoni
  tableHTML += `
      <tr class="accumulatorOddsRow">
        <td colspan="3" class="buttonsCell">
          <div class="buttons">
            <button class="estimator" onclick="estimator()">Stimatore</button>
            <button class="development" onclick="development()">Sviluppo</button>
            <button class="save" onclick="openSavePopup()">Salva</button>
            <button class="load" onclick="openLoadOrDeletePopup()">Carica o elimina</button>
            <button class="update" onclick="updateAccumulator()">Aggiorna</button>
          </div>
        </td>
        <td class="accumulatorOddsCell"><h4>Q. MULTIPLA: <span id="accumulatorOdds">-</span></h4></td>        
        <td colspan="2"></td>
        <td class="clearButtonCell">
          <button class="clearAll" onclick="clearAllInputs()" title="Cancella tutti i dati">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="3,6 5,6 21,6"></polyline>
              <path d="m19,6v14a2,2 0 0,1-2,2H7a2,2 0 0,1-2-2V6m3,0V4a2,2 0 0,1 2-2h4a2,2 0 0,1 2,2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  `;
  
  // Salva i valori già inseriti
  const savedData = {};
  document.querySelectorAll("input, select").forEach(el => {
    if (el.id) savedData[el.id] = el.value;
  });

  primaryTable.innerHTML = tableHTML;

  // Ripristina i valori salvati (se ancora esistono nei nuovi input)
  for (const id in savedData) {
    const el = document.getElementById(id);
    if (el) el.value = savedData[id];
  }
  calculateAccumulatorOdds();
  updateAllExpansionData();
  syncInputWidths();
  attachCopyListeners();
}

// Gestisce l'animazione del bottone per l'espansione
function toggleExpansion(legIndex) {
  const expansionContent = document.getElementById(`expansionContent${legIndex}`);
  const allArrows = document.querySelectorAll('.expandButton .arrow');
  const arrow = allArrows[legIndex];

  const isOpen = expansionContent.classList.contains('show');

  if (isOpen) {
    expansionContent.classList.remove('show');
    arrow.classList.remove('rotated');
    // Non rilanciare l'animazione in chiusura
  } else {
    expansionContent.classList.add('show');
    arrow.classList.add('rotated');
    updateExpansionData(legIndex);

    // Rilancia animazione se già aperto
    arrow.classList.remove('retrigger');
    void arrow.offsetWidth;
    arrow.classList.add('retrigger');
  }
  syncInputWidths();
  attachCopyListeners();
}

// Calcola la larghezza di un input della prima colonna della quote nuove e applicala a tutti gli input numerici dei dati iniziali
function syncInputWidths() {
    // Trova la larghezza di un input della prima colonna delle quote nuove
    const referenceInputs = document.querySelectorAll('.expansionContent.show .oddsColumn input');
    if (referenceInputs.length > 0) {
        const referenceWidth = referenceInputs[0].offsetWidth;
        // Applica la stessa larghezza a tutti gli input numerici dei dati iniziali visibili
        document.querySelectorAll('.expansionContent.show .initialData .form1 input[type="number"]').forEach(input => {
            input.style.width = referenceWidth + 'px';
        });
    }
}

// Calcola la quota totale della multipla
function calculateAccumulatorOdds() {
  const legs = parseInt(document.getElementById("legs").value);
  let accumulatorOdds = 1;
  let allFieldsFilled = true;
  
  for (let i = 0; i < legs; i++) {
    const backOdds = parseFloat(document.getElementById("backOdds" + i).value);
    
    // Controlla se il campo è vuoto o ha valore non valido
    if (!backOdds || backOdds <= 0) {
      allFieldsFilled = false;
      break;
    }
    
    accumulatorOdds *= backOdds;
  }
  
  // Mostra "-" se non tutti i campi sono compilati, altrimenti mostra la quota calcolata
  if (allFieldsFilled) {
    document.getElementById("accumulatorOdds").textContent = accumulatorOdds.toFixed(2);
    return accumulatorOdds;
  } else {
    document.getElementById("accumulatorOdds").textContent = "-";
    // Restituisce 1 come fallback per i calcoli
    return 1;
  }
}

// Mostra i dati iniziali per un leg
function updateExpansionData(legIndex) {
  const legs = parseInt(document.getElementById("legs").value);
  const backStake = parseFloat(document.getElementById("backStake").value) || 0;
  const backOdds = calculateAccumulatorOdds();
  const refund = parseFloat(document.getElementById("refund").value) || 0;
  const layOdds = parseFloat(document.getElementById(`layOdds${legIndex}`).value) || 1;
  const layCommission = parseFloat(document.getElementById(`commission${legIndex}`).value) || 0;  
  const mode = refund > 0 ? "rimborso" : "normale";

  // Calcola la bancata di ogni leg
  const layAmounts = calculateLayAmounts({
    legs, backStake, backOdds, mode, 
    layOdds: Array(legs).fill(0).map((_, i) => parseFloat(document.getElementById(`layOdds${i}`).value) || 1),
    layCommission: Array(legs).fill(0).map((_, i) => parseFloat(document.getElementById(`commission${i}`).value) || 0),
    refund
  });

  let allFormsFilled = backStake > 0;
  for (let i = 0; i < legs; i++) {
    const backOddsValue = parseFloat(document.getElementById(`backOdds${i}`).value);
    const layOddsValue = parseFloat(document.getElementById(`layOdds${i}`).value);
    if (!backOddsValue || backOddsValue <= 0 || !layOddsValue || layOddsValue <= 0) {
      allFormsFilled = false;
      break;
    }
  }
  const layAmount = allFormsFilled ? (layAmounts[legIndex] || 0) : null;
  // Aggiorna i dati iniziali
  document.getElementById(`initialLayOdds${legIndex}`).textContent = layOdds === 1 ? "-" : `@${layOdds.toFixed(2)}`;
  document.getElementById(`initialCommission${legIndex}`).textContent = `${layCommission.toFixed(1)}%`;
  if (layAmount === null || !allFormsFilled) {
    document.getElementById(`initialLayAmount${legIndex}`).textContent = '-';
    document.getElementById(`initialLayAmount${legIndex}`).classList.remove('copyable-value');
    document.getElementById(`initialLayAmount${legIndex}`).removeAttribute('title');
  } else {
    document.getElementById(`initialLayAmount${legIndex}`).textContent = `${layAmount.toFixed(2)} €`;
    document.getElementById(`initialLayAmount${legIndex}`).classList.add('copyable-value');
    document.getElementById(`initialLayAmount${legIndex}`).title = 'Clicca per copiare';
  }
}

// Mostra i dati iniziali per tutti i leg
function updateAllExpansionData() {
  const legs = parseInt(document.getElementById("legs").value);
  for (let i = 0; i < legs; i++) {
    updateExpansionData(i);
  }
}

// Calcola gli importi di bancata
function calculateLayAmounts({ legs, backStake, backOdds, mode, layOdds, layCommission, refund }) {
  let profitTarget;
  
  if (mode === "normale") {
    // Modalità normale: vogliamo coprire la vincita potenziale del bookmaker
    profitTarget = backOdds * backStake;
  } else {
    // Modalità rimborso: vogliamo coprire la differenza tra vincita e rimborso
    profitTarget = (backOdds * backStake) - refund;
  }

  let layAmounts = [];

  for (let i = 0; i < legs; i++) {
    let divisor = 1;
    for (let j = i; j < legs; j++) {
      const lo = layOdds[j];
      const lc = layCommission[j] / 100;
      // Gestione commissione 0: se la commissione è 0, non sottrarre nulla
      const netOdds = layCommission[j] > 0 ? (lo - lc) : lo;
      divisor *= netOdds;
    }

    let multiplier = 1;
    for (let k = i + 1; k < legs; k++) {
      // Gestione commissione 0: se la commissione è 0, moltiplicatore rimane 1
      const commissionFactor = layCommission[k] > 0 ? (1 - layCommission[k] / 100) : 1;
      multiplier *= commissionFactor;
    }

    const layAmount = (profitTarget / divisor) * multiplier;
    layAmounts.push(layAmount);
  }

  return layAmounts;
}

// Mostra le quote nuove per un leg
function updateCoverage(legIndex) {
  const backStake = parseFloat(document.getElementById("backStake").value) || 0;
  const backOdds = parseFloat(document.getElementById(`backOdds${legIndex}`).value) || 1;      
  const refund = parseFloat(document.getElementById("refund").value) || 0;
  const initialLayAmount = parseFloat(document.getElementById(`initialLayAmount${legIndex}`).textContent.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
  const initialCommission = parseFloat(document.getElementById(`initialCommission${legIndex}`).textContent.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;    
  const initialPairedAmount = parseFloat(document.getElementById(`pairedAmount${legIndex}`).value) || 0;
  const initialCoverage = initialPairedAmount / initialLayAmount;

  // Inizializza la copertura del giro precedente con quella iniziale
  let previousRoundCoverage = initialCoverage;

  // Calcola per le 5 quote nuove
  for (let i = 1; i <= 5; i++) {
    const initialLayOdds = parseFloat(document.getElementById(`layOdds${legIndex}`).value) || 1;
    const layOdds = parseFloat(document.getElementById(`newOdds${i}${legIndex}`).value) || 0;
    const commisssion = parseFloat(document.getElementById(`newCommission${i}${legIndex}`).value) || 0;
    const pairedAmount = parseFloat(document.getElementById(`pairedAmount${i}${legIndex}`).value) || 0;
  
    if (layOdds > 0 && commisssion >= 0) {
      // Calcola la puntata ipotetica in funzione della bancata iniziale
      const hypotheticalStake = (initialLayAmount * (initialLayOdds - initialCommission / 100) + refund) / backOdds;
      // Calcola la bancata necessaria per coprire l'importo rimanente
      const layAmount = (hypotheticalStake * backOdds - refund) * (1 - previousRoundCoverage) / (layOdds - commisssion / 100);          
      
      // Verifica che tutti i campi necessari siano compilati per ogni evento
      let allFormsFilled = backStake > 0;
      for (let j = 0; j < parseInt(document.getElementById("legs").value); j++) {
        const backOddsValue = parseFloat(document.getElementById(`backOdds${j}`).value);
        const layOddsValue = parseFloat(document.getElementById(`layOdds${j}`).value);
        if (!backOddsValue || backOddsValue <= 0 || !layOddsValue || layOddsValue <= 0) {
          allFormsFilled = false;
          break;
        }
      }

      // Aggiorna il display della bancata
      if (!allFormsFilled || !layOdds) {
        document.getElementById(`layAmount${i}${legIndex}`).textContent = '-';
        document.getElementById(`layAmount${i}${legIndex}`).classList.remove('copyable-value');
        document.getElementById(`layAmount${i}${legIndex}`).removeAttribute('title');
      } else {
        document.getElementById(`layAmount${i}${legIndex}`).textContent = `${layAmount.toFixed(2)} €`;
        document.getElementById(`layAmount${i}${legIndex}`).classList.add('copyable-value');
        document.getElementById(`layAmount${i}${legIndex}`).title = 'Clicca per copiare';
      }
      
      // Calcola la nuova copertura usando la copertura del giro precedente
      const totalCoverage = pairedAmount / layAmount * (1 - previousRoundCoverage) + previousRoundCoverage;
      
      // Aggiorna la copertura del giro precedente per la prossima iterazione
      previousRoundCoverage = totalCoverage;
    
    } else {
      // Resetta se non ci sono valori validi o non c'è più nulla da coprire
      document.getElementById(`layAmount${i}${legIndex}`).textContent = '-';
      document.getElementById(`layAmount${i}${legIndex}`).classList.remove('copyable-value');
      document.getElementById(`layAmount${i}${legIndex}`).removeAttribute('title');
    }
  }
}

// Mostra le quote nuove per tutti i leg
function updateAllCoverage() {
  const legs = parseInt(document.getElementById("legs").value);
  for (let i = 0; i < legs; i++) {
    updateCoverage(i);
  }
}

// Mostra profitto e responsabilità stimati
function calculateEstimation() {
  const legs = parseInt(document.getElementById("legs").value);
  const backStake = parseFloat(document.getElementById("backStake").value);
  const bonus = parseFloat(document.getElementById("bonus").value) || 0;
  const refund = parseFloat(document.getElementById("refund").value) || 0;

  // Determina la modalità in base al valore rimborso
  const mode = refund > 0 ? "rimborso" : "normale";

  // Verifica se tutti i campi essenziali sono compilati
  if (!backStake || backStake <= 0) {
    document.getElementById("estimatedProfit").textContent = "-";
    document.getElementById("estimatedLiability").textContent = "-";
    // Aggiorna comunque i dati del riquadro di espansione per mostrare "-"
    updateAllExpansionData();
    return;
  }

  let layOddsList = [], layCommissionsList = [], backOddsList = [];
  let allFormsValid = true;

  for (let i = 0; i < legs; i++) {
    const backOdds = parseFloat(document.getElementById("backOdds" + i).value);
    const layOdds = parseFloat(document.getElementById("layOdds" + i).value);
    const layCommission = parseFloat(document.getElementById("commission" + i).value);
    
    // Controlla se mancano dati essenziali
    if (!backOdds || backOdds <= 0 || !layOdds || layOdds <= 0 || layCommission === undefined || layCommission === null || layCommission < 0) {
      allFormsValid = false;
      break;
    }
    
    backOddsList.push(backOdds);
    layOddsList.push(layOdds);
    layCommissionsList.push(layCommission);
  }

  if (!allFormsValid) {
    document.getElementById("estimatedProfit").textContent = "-";
    document.getElementById("estimatedLiability").textContent = "-";
    // Aggiorna i dati del riquadro di espansione per mostrare "-"
    updateAllExpansionData();
    return;
  }

  const accumulatorOdds = calculateAccumulatorOdds();

  const layAmounts = calculateLayAmounts({
    legs, backStake, backOdds: accumulatorOdds, mode, layOdds: layOddsList, layCommission: layCommissionsList, refund
  });

  const profit = calculateEstimatedProfit({
    mode, backStake, accumulatorOdds, layOdds: layOddsList, layAmounts, refund, bonus
  });

  const liability = calculateEstimatedLiability(layOddsList, layAmounts);

  // Aggiorna i valori
  document.getElementById("estimatedProfit").textContent = `€ ${profit.toFixed(2)}`;
  document.getElementById("estimatedLiability").textContent = `€ ${liability.toFixed(2)}`;
    
  // Aggiorna i dati del riquadro di espansione
  updateAllExpansionData();
}

// Calcola il profitto stimato
function calculateEstimatedProfit({ mode, backStake, accumulatorOdds, layOdds, layAmounts, refund, bonus }) {
  let bookmakerWinnings = mode === "normale"
    ? accumulatorOdds * backStake
    : (accumulatorOdds - 1) * backStake;

  let totalLiability = 0;
  for (let i = 0; i < layAmounts.length; i++) {
    totalLiability += layAmounts[i] * (layOdds[i] - 1);
  }

  let profit = mode === "normale" 
    ? bookmakerWinnings - totalLiability - backStake
    : bookmakerWinnings - totalLiability;

  // Somma il bonus per entrambe le modalità
  profit += bonus;

  return profit;
}

// Calcola la responsabilità stimata
function calculateEstimatedLiability(layOdds, stakes) {
  let totalLiability = 0;
  
  for (let i = 0; i < layOdds.length; i++) {
    const liability = stakes[i] * (layOdds[i] - 1);
    totalLiability += liability;
  }
  
  return totalLiability;
}

// Calcola il profitto effettivo
function calculateDevelopment() {
  const backStake = parseFloat(document.getElementById("backStake").value) || 0;
  const bonus = parseFloat(document.getElementById("bonus").value) || 0;
  const refund = parseFloat(document.getElementById("refund").value) || 0;
  const accumulatorOdds = parseFloat(document.getElementById("accumulatorOdds").innerText) || 1;
  const legs = parseInt(document.getElementById("legs").value);
  let actualProfit = null;
  let accumulatorEnded = false;
  let winningLegs = 0;
  
  for (let i = 0; i < legs && !accumulatorEnded; i++) {
    const statusRadios = document.querySelectorAll(`input[name="status${i}"]`);
    // Status di default
    let status = "A";
   
    // Trova lo status selezionato
    for (const radio of statusRadios) {
      if (radio.checked) {
        status = radio.value;
        break;
      }
    }
   
    if (status === "V") {
      winningLegs++;
      
      // Leg vincente: calcola perdita momentanea
      let momentaryLoss = 0;
     
      // Perdita dall'abbinamento iniziale
      const initialPairedAmount = parseFloat(document.getElementById(`pairedAmount${i}`)?.value) || 0;
      const layOdds = parseFloat(document.getElementById(`layOdds${i}`)?.value) || 1;
     
      if (initialPairedAmount > 0) {
        const initialLoss = initialPairedAmount * (layOdds - 1);
        momentaryLoss += initialLoss;
      }
     
      // Perdite dagli abbinamenti parziali (nuove quote)
      for (let j = 1; j <= 5; j++) {
        const partialPairedAmount = parseFloat(document.getElementById(`pairedAmount${j}${i}`)?.value) || 0;
        const layOdds = parseFloat(document.getElementById(`newOdds${j}${i}`)?.value) || 0;
       
        if (partialPairedAmount > 0 && layOdds > 0) {
          const partialLoss = partialPairedAmount * (layOdds - 1);
          momentaryLoss += partialLoss;
        }
      }
     
      actualProfit -= momentaryLoss;
     
    } else if (status === "P") {
      // Leg perdente: calcola profitto e concludi multipla
      let legProfit;
      if (bonus > 0) {
          legProfit = refund;
      } else {
          legProfit = -backStake + refund;
      }
     
      // Profitto dall'abbinamento iniziale
      const initialPairedAmount = parseFloat(document.getElementById(`pairedAmount${i}`)?.value) || 0;
      const initialCommission = parseFloat(document.getElementById(`initialCommission${i}`)?.textContent?.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
     
      if (initialPairedAmount > 0) {
        const initialProfit = initialPairedAmount - (initialPairedAmount * initialCommission / 100);
        legProfit += initialProfit;
      }
     
      // Profitti dagli abbinamenti parziali
      for (let j = 1; j <= 5; j++) {
        const partialPairedAmount = parseFloat(document.getElementById(`pairedAmount${j}${i}`)?.value) || 0;
        const commisssion = parseFloat(document.getElementById(`newCommission${j}${i}`)?.value) || 0;
       
        if (partialPairedAmount > 0 && commisssion >= 0) {
          const partialProfit = partialPairedAmount - (partialPairedAmount * commisssion / 100);
          legProfit += partialProfit;
        }
      }
     
      actualProfit += legProfit;
      accumulatorEnded = true;
    }
    // Se status === "A", non facciamo nulla per questo leg
  }
  
  // Se tutti i leg sono vincenti, calcola il profitto della multipla vincente
  if (!accumulatorEnded && winningLegs === legs) {
    const accumulatorProfit = backStake * accumulatorOdds - backStake + bonus;
    // Il profitto effettivo è già stato decrementato delle perdite durante il loop
    actualProfit += accumulatorProfit;
  }
  
  // Aggiorna il display  
  if (actualProfit !== null) {
    document.getElementById("actualProfit").textContent = `€ ${actualProfit.toFixed(2)}`;
  }  
}

// Aggiorna il profitto effettivo
function calculateDevelopmentAutomatically() {
  // Solo se il pannello sviluppo è visibile
  if (developmentIsVisible) {
    calculateDevelopment();
  }
}

// Mostra il bottone stimatore
function estimator() {
  const estimatorDisplay = document.getElementById("estimatorDisplay");
  const developmentDisplay = document.getElementById("developmentDisplay");
  
  if (estimatorIsVisible) {
    estimatorDisplay.classList.remove("show");
    estimatorIsVisible = false;
  } else {
    // Nascondi l'altro pannello se è aperto
    if (developmentIsVisible) {
      developmentDisplay.classList.remove("show");
      developmentIsVisible = false;
    }
    
    // Calcola profitto e responsabilità stimati
    calculateEstimation();
    estimatorDisplay.classList.add("show");
    estimatorIsVisible = true;
  }
}

// Mostra il bottone sviluppo
function development() {
  const developmentDisplay = document.getElementById("developmentDisplay");
  const estimatorDisplay = document.getElementById("estimatorDisplay");
  
  if (developmentIsVisible) {
    developmentDisplay.classList.remove("show");
    developmentIsVisible = false;
  } else {
    // Nascondi l'altro pannello se è aperto
    if (estimatorIsVisible) {
      estimatorDisplay.classList.remove("show");
      estimatorIsVisible = false;
    }
    
    // Calcola il profitto effettivo
    calculateDevelopment();
    developmentDisplay.classList.add("show");
    developmentIsVisible = true;
  }
}

// Cancella tutti gli input della pagina
function clearAllInputs() {
  // Conferma prima di cancellare
  if (confirm('Sei sicuro di voler cancellare tutti i dati inseriti?')) {
    // Resetta tutti gli input text, number e date
    document.querySelectorAll('input[type="text"], input[type="number"], input[type="datetime-local"]').forEach(input => {
      input.value = '';
    });
    
    // Resetta tutti i select al primo valore
    document.querySelectorAll('select').forEach(select => {
      select.selectedIndex = 0;
    });
    
    // Resetta tutti i radio button al primo (status "A")
    document.querySelectorAll('input[type="radio"]').forEach((radio, index) => {
      if (radio.value === 'A') {
        radio.checked = true;
      } else {
        radio.checked = false;
      }
    });
    
    // Resetta i display dei risultati
    document.getElementById("accumulatorOdds").textContent = "-";
    document.getElementById("estimatedProfit").textContent = "-";
    document.getElementById("estimatedLiability").textContent = "-";
    document.getElementById("actualProfit").textContent = "-";
    
    // Nascondi i pannelli se visibili
    if (estimatorIsVisible) {
      document.getElementById("estimatorDisplay").classList.remove("show");
      estimatorIsVisible = false;
    }
    if (developmentIsVisible) {
      document.getElementById("developmentDisplay").classList.remove("show");
      developmentIsVisible = false;
    }

    // Reset variabili multipla caricata e nascondi label
    currentLoadedAccumulatorId = null;
    currentLoadedAccumulatorName = null;
    document.getElementById('loadedMultiplaLabel').style.display = 'none';
    document.getElementById('loadedMultiplaName').textContent = '';
    
    // Chiudi tutte le espansioni
    document.querySelectorAll('.expansionContent').forEach(content => {
      content.classList.remove('show');
    });
    document.querySelectorAll('.expandButton .arrow').forEach(arrow => {
      arrow.classList.remove('rotated');
    });
    
    // Rigenera la tabella per essere sicuri che tutto sia pulito
    renderLegs();
  }
}

// Funzioni per il salvataggio
function openSavePopup() {
    document.getElementById('savePopup').classList.add('show');
    document.getElementById('accumulatorName').value = '';
    document.getElementById('accumulatorName').focus();
}

function closeSavePopup() {
    document.getElementById('savePopup').classList.remove('show');
}

function saveAccumulator() {
    const name = document.getElementById('accumulatorName').value.trim();
    if (!name) {
        alert('Inserisci un nome per la multipla');
        return;
    }

    const data = collectAccumulatorData();
    
    db.collection('multiple').add({
        name: name,
        data: data,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
    })
    .then(() => {
        closeSavePopup();
    })
    .catch((error) => {
        console.error('Errore nel salvataggio:', error);
        alert('Errore nel salvataggio della multipla');
    });
}

function collectAccumulatorData() {
    const legs = parseInt(document.getElementById("legs").value);
    const data = {
        legs: legs,
        backStake: document.getElementById("backStake").value,
        bonus: document.getElementById("bonus").value,
        refund: document.getElementById("refund").value,
        legsData: []
    };

    for (let i = 0; i < legs; i++) {
        const legData = {
            match: document.getElementById(`match${i}`).value,
            date: document.getElementById(`date${i}`).value,
            market: document.getElementById(`market${i}`).value,
            backOdds: document.getElementById(`backOdds${i}`).value,
            layOdds: document.getElementById(`layOdds${i}`).value,
            commission: document.getElementById(`commission${i}`).value,
            status: document.querySelector(`input[name="status${i}"]:checked`).value,
            pairedAmount: document.getElementById(`pairedAmount${i}`).value || '',
            newOdds: [],
            newCommissions: [],
            pairedAmounts: []
        };

        // Raccogli i dati delle nuove quote
        for (let j = 1; j <= 5; j++) {
            legData.newOdds.push(document.getElementById(`newOdds${j}${i}`).value || '');
            legData.newCommissions.push(document.getElementById(`newCommission${j}${i}`).value || '');
            legData.pairedAmounts.push(document.getElementById(`pairedAmount${j}${i}`).value || '');
        }

        data.legsData.push(legData);
    }

    return data;
}

// Funzioni per il caricamento
function openLoadOrDeletePopup() {
    document.getElementById('loadOrDeletePopup').classList.add('show');
    loadSavedAccumulators();
}

function closeLoadOrDeletePopup() {
    document.getElementById('loadOrDeletePopup').classList.remove('show');
}

function loadSavedAccumulators() {
    const listContainer = document.getElementById('accumulatorsList');
    listContainer.innerHTML = '<p>Caricamento...</p>';

    db.collection('multiple')
        .orderBy('timestamp', 'desc')
        .get()
        .then((querySnapshot) => {
            if (querySnapshot.empty) {
                listContainer.innerHTML = '<p>Nessuna multipla salvata</p>';
                return;
            }

            let html = '';
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                html += `
                    <div class="savedAccumulators">
                        <span><strong>${data.name}</strong> (${data.data.legs} eventi)</span>
                        <div class="savedAccumulatorsButtons">
                            <button class="primaryActionButton" onclick="loadAccumulator('${doc.id}')">Carica</button>
                            <button class="deleteButton" onclick="deleteAccumulator('${doc.id}')">Elimina</button>
                        </div>
                    </div>
                `;
            });
            listContainer.innerHTML = html;
        })
        .catch((error) => {
            console.error('Errore nel caricamento:', error);
            listContainer.innerHTML = '<p>Errore nel caricamento delle multiple</p>';
        });
}

function loadAccumulator(docId) {
    db.collection('multiple').doc(docId).get()
        .then((doc) => {
            if (doc.exists) {
                const data = doc.data();
                currentLoadedAccumulatorId = docId;
                currentLoadedAccumulatorName = data.name;
                restoreAccumulatorData(data.data);
                document.getElementById('loadedMultiplaName').textContent = data.name;
                document.getElementById('loadedMultiplaLabel').style.display = 'flex';
                closeLoadOrDeletePopup();                
            }
        })
        .catch((error) => {
            console.error('Errore nel caricamento:', error);
            alert('Errore nel caricamento della multipla');
        });
}

function restoreAccumulatorData(data) {
    // Imposta il numero di eventi
    document.getElementById("legs").value = data.legs;
    renderLegs();

    // Ripristina i dati principali
    document.getElementById("backStake").value = data.backStake || '';
    document.getElementById("bonus").value = data.bonus || '';
    document.getElementById("refund").value = data.refund || '';

    // Ripristina i dati di ogni evento
    data.legsData.forEach((legData, i) => {
        document.getElementById(`match${i}`).value = legData.match || '';
        document.getElementById(`date${i}`).value = legData.date || '';
        document.getElementById(`market${i}`).value = legData.market || '';
        document.getElementById(`backOdds${i}`).value = legData.backOdds || '';
        document.getElementById(`layOdds${i}`).value = legData.layOdds || '';
        document.getElementById(`commission${i}`).value = legData.commission || '';
        document.getElementById(`pairedAmount${i}`).value = legData.pairedAmount || '';

        // Imposta lo status
        document.querySelector(`input[name="status${i}"][value="${legData.status}"]`).checked = true;

        // Ripristina le nuove quote
        for (let j = 1; j <= 5; j++) {
            const idx = j - 1;
            document.getElementById(`newOdds${j}${i}`).value = legData.newOdds[idx] || '';
            document.getElementById(`newCommission${j}${i}`).value = legData.newCommissions[idx] || '';
            document.getElementById(`pairedAmount${j}${i}`).value = legData.pairedAmounts[idx] || '';
        }
    });

    // Ricalcola tutto
    calculateAccumulatorOdds();
    calculateEstimation();
    updateAllCoverage();
    calculateDevelopmentAutomatically();
}

function deleteAccumulator(docId) {
    if (confirm('Sei sicuro di voler eliminare questa multipla?')) {
        db.collection('multiple').doc(docId).delete()
            .then(() => {
                // Ricarica la lista
                loadSavedAccumulators();
                // Reset variabili multipla caricata e nascondi label
                currentLoadedAccumulatorId = null;
                currentLoadedAccumulatorName = null;
                document.getElementById('loadedMultiplaLabel').style.display = 'none';
                document.getElementById('loadedMultiplaName').textContent = '';
            })
            .catch((error) => {
                console.error('Errore nell\'eliminazione:', error);
                alert('Errore nell\'eliminazione della multipla');
            });
    }
}

function updateAccumulator() {
    if (!currentLoadedAccumulatorId) {
        alert('Carica prima una multipla per aggiornarla');
        return;
    }

    const data = collectAccumulatorData();
    
    db.collection('multiple').doc(currentLoadedAccumulatorId).update({
        data: data,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
    })
    .then(() => {
        alert('Multipla aggiornata con successo');
    })
    .catch((error) => {
        console.error('Errore nell\'aggiornamento:', error);
        alert('Errore nell\'aggiornamento della multipla');
    });
}

// Copia un valore negli appunti con feedback visivo
function copyToClipboard(elementId) {
    const element = document.getElementById(elementId);
    if (!element) return;
    
    // Estrae solo il valore numerico dal testo
    let text = element.textContent.trim();
        
    // Rimuove simboli di valuta e spazi
    text = text.replace(/[€\s]/g, '');
    
    // Se il valore è "-" o vuoto, non copiare
    if (text === '-' || text === '' || text === 'NaN') {
        return;
    }
    
    // Copia il valore negli appunti
    navigator.clipboard.writeText(text).then(() => {
        // Feedback visivo temporaneo
        element.classList.add('copied');
        setTimeout(() => {
            element.classList.remove('copied');
        }, 1000);
    }).catch(err => {
        console.error('Errore nella copia:', err);
        // Fallback per browser che non supportano clipboard API
        fallbackCopyText(text, element);
    });
}

// Funzione fallback per browser più vecchi
function fallbackCopyText(text, element) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    
    textArea.focus();
    textArea.select();
    
    try {
        document.execCommand('copy');
        // Feedback visivo
        element.classList.add('copied');
        setTimeout(() => {
            element.classList.remove('copied');
        }, 1000);
    } catch (err) {
        console.error('Fallback: errore nella copia', err);
    }
    
    document.body.removeChild(textArea);
}

// Aggiunge event listener per tutti gli elementi copiabili
function attachCopyListeners() {
    const legs = parseInt(document.getElementById("legs").value);
    
    // Event listener per i dati iniziali
    for (let i = 0; i < legs; i++) {
        const initialLayAmount = document.getElementById(`initialLayAmount${i}`);
        if (initialLayAmount) {
            initialLayAmount.onclick = () => copyToClipboard(`initialLayAmount${i}`);
        }
        
        // Event listener per le quote nuove
        for (let j = 1; j <= 5; j++) {
            const layAmount = document.getElementById(`layAmount${j}${i}`);
            if (layAmount) {
                layAmount.onclick = () => copyToClipboard(`layAmount${j}${i}`);
            }
        }
    }
}

// Inizializza la pagina
document.addEventListener('DOMContentLoaded', function() {
  renderLegs();
});
// Event listener per sincronizzare le larghezze durante il ridimensionamento
window.addEventListener('resize', syncInputWidths);